import { Icon } from 'LocalGluons';
import React from 'react';
import { View } from 'react-native';
import styles from './NativeConsentsCheckBox.jss';

interface CheckBoxProps {
    approval: boolean;
    borderColor: string;
    borderRadius: number;
    size: number;
    iconColor?: string;
    backgroundColor?: string;
}
const Checkbox = ({
    approval,
    borderColor,
    borderRadius,
    size,
    iconColor,
    backgroundColor
}: CheckBoxProps) => {
    const iconName = iconColor === 'white' ? 'checkmark' : 'confirm';

    const checkboxStyle = {
        borderColor,
        borderRadius,
        width: size,
        height: size,
        backgroundColor:
            backgroundColor === 'none' ? 'transparent' : backgroundColor || 'defaultColor'
    };

    return (
        <View style={[styles.checkboxContainer, checkboxStyle]}>
            {approval && <Icon style={styles.iconPosition} name={iconName} />}
        </View>
    );
};

export default Checkbox;
